import { apiClient } from './api';
import type {
  CoachProfileApplyPresetResponse,
  CoachProfilePresetsResponse,
  CoachProfileSettingsResponse,
} from './types';

interface UpdateProfileResponse {
  profile: CoachProfileSettingsResponse['profile'];
}

export class CoachProfileSettingsService {
  static async getProfile(): Promise<CoachProfileSettingsResponse> {
    const response = await apiClient.get<CoachProfileSettingsResponse>('/api/coach-profile');
    return response.data;
  }

  static async updateProfile(data: Record<string, unknown>): Promise<UpdateProfileResponse> {
    const response = await apiClient.put<UpdateProfileResponse>('/api/coach-profile', data);
    return response.data;
  }

  static async getPresets(): Promise<CoachProfilePresetsResponse> {
    const response = await apiClient.get<CoachProfilePresetsResponse>('/api/coach-profile/presets');
    return response.data;
  }

  static async applyPreset(preset: string): Promise<CoachProfileApplyPresetResponse> {
    const response = await apiClient.post<CoachProfileApplyPresetResponse>(
      '/api/coach-profile/apply-preset',
      { preset },
    );
    return response.data;
  }
}
